import s from './ResourceListHero.module.css';

/* ResourceListHero — shared Solutions-style header for resource list pages.
   Pass the same eyebrow/title/subtitle strings the page already used; this
   only changes the header chrome (content is unchanged). */
export default function ResourceListHero({ eyebrow, title, subtitle }) {
  return (
    <section className={s.hero}>
      <div className={s.bg} aria-hidden="true">
        <div className={s.orb1} />
        <div className={s.orb2} />
        <div className={s.dotted} />
      </div>
      <div className={`container ${s.inner}`}>
        {eyebrow && (
          <span className={s.capsule}>
            <span className={s.capsuleDot} aria-hidden="true" />
            {eyebrow}
          </span>
        )}
        {title && <h1 className={s.title}>{title}</h1>}
        {subtitle && <p className={s.subtitle}>{subtitle}</p>}
      </div>
    </section>
  );
}
